import React, { forwardRef, ReactNode } from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { Form } from '@ant-design/compatible';
import { ValidationRule } from '@ant-design/compatible/lib/form/Form';
import cx from 'classnames';
import Input from '../../../../../../components/input/Input';
import { ColorInputFormStyle, PreviewStyle } from './style';

interface ColorInputProps {
  value?: string;
  onChange?: (data: string) => void;
  maxLength?: number;
}
const ColorInput = forwardRef<HTMLDivElement, ColorInputProps>((props, ref) => {
  const { value, onChange, maxLength } = props;
  return (
    <div ref={ref}>
      <PreviewStyle className="preview" backgroundColor={value}></PreviewStyle>
      <Input value={value} onChange={onChange} maxLength={maxLength} />
    </div>
  );
});
ColorInput.displayName = 'ColorInput';

interface ColorInputFormProps extends FormComponentProps {
  label?: string | ReactNode;
  name: string;
  rules?: ValidationRule[];
  initialValue?: string;
  maxLength?: number;
}

const ColorInputForm = (props: ColorInputFormProps) => {
  const { form, label, name, rules, initialValue, maxLength } = props;
  const { getFieldDecorator } = form;

  return (
    <ColorInputFormStyle>
      <Form.Item className={cx('color-input-form', 'amondz-form', { 'with-label': label })} label={label}>
        {getFieldDecorator(name, {
          rules,
          initialValue,
        })(<ColorInput maxLength={maxLength} />)}
      </Form.Item>
    </ColorInputFormStyle>
  );
};

export default ColorInputForm;
